(function () {
  "use strict";

  const nativeFormsSent = new WeakSet();
  const klaviyoFormsSent = new Set();

  function klaviyoIsAvailable() {
    return (
      window.klaviyo &&
      typeof window.klaviyo.track === "function"
    );
  }

  function getEmail(form) {
    const emailInput = form.querySelector(
      'input[type="email"], ' +
      'input[name="contact[email]"], ' +
      'input[name="email"]'
    );

    if (!emailInput) return "";

    const email = String(emailInput.value || "").trim();

    if (!email.includes("@")) return "";

    return email;
  }

  function isRelevantForm(form) {
    if (!(form instanceof HTMLFormElement)) return false;

    /*
     * Klaviyo-Formulare werden separat über
     * das offizielle klaviyoForms-Ereignis erfasst.
     */
    if (
      form.closest(
        '[class*="klaviyo"], [id*="klaviyo"]'
      )
    ) {
      return false;
    }

    /*
     * Suchformular ausschließen.
     */
    if (
      form.querySelector(
        'input[type="search"], input[name="q"]'
      )
    ) {
      return false;
    }

    const action = String(
      form.getAttribute("action") || ""
    ).toLowerCase();

    /*
     * Warenkorb, Checkout und Kundenkonto ausschließen.
     */
    if (
      action.includes("/cart") ||
      action.includes("/checkout") ||
      action.includes("/account")
    ) {
      return false;
    }

    /*
     * Produktformular ausschließen.
     */
    if (
      form.querySelector('input[name="id"]') &&
      form.querySelector(
        '[name="add"], .m-add-to-cart'
      )
    ) {
      return false;
    }

    /*
     * Rabattformular ausschließen.
     */
    if (
      form.querySelector(
        'input[name="discount"], input[name="discount_code"]'
      )
    ) {
      return false;
    }

    /*
     * Nur Formulare mit E-Mail oder Nachricht erfassen.
     */
    return Boolean(
      form.querySelector(
        'input[type="email"], ' +
        'input[name="contact[email]"], ' +
        'textarea'
      )
    );
  }

  function getFormType(form) {
    const tagsInput = form.querySelector(
      'input[name="contact[tags]"]'
    );

    const description = [
      form.id,
      form.className,
      form.getAttribute("name"),
      form.getAttribute("action"),
      form.getAttribute("aria-label"),
      tagsInput ? tagsInput.value : ""
    ]
      .map(function (value) {
        return String(value || "");
      })
      .join(" ")
      .toLowerCase();

    if (
      /back.?in.?stock|restock|notify|wieder.?auf.?lager/.test(
        description
      )
    ) {
      return "Wieder-auf-Lager";
    }

    if (
      /newsletter|subscribe|subscription|abonn|email.?signup/.test(
        description
      )
    ) {
      return "Newsletter";
    }

    if (
      /contact|kontakt/.test(description) ||
      form.querySelector("textarea")
    ) {
      return "Kontaktformular";
    }

    return "Lead-Formular";
  }

  function getFormName(form, formType) {
    return (
      form.getAttribute("data-form-name") ||
      form.getAttribute("aria-label") ||
      form.getAttribute("name") ||
      form.id ||
      formType
    );
  }

  function identifyEmail(email) {
    if (
      !email ||
      !window.klaviyo ||
      typeof window.klaviyo.identify !== "function"
    ) {
      return Promise.resolve();
    }

    return new Promise(function (resolve) {
      let completed = false;

      function finish() {
        if (completed) return;

        completed = true;
        resolve();
      }

      try {
        const result = window.klaviyo.identify(
          {
            email: email
          },
          finish
        );

        if (
          result &&
          typeof result.then === "function"
        ) {
          result.then(finish).catch(finish);
        }

        setTimeout(finish, 700);
      } catch (error) {
        console.error(
          "Fehler bei der Formular-Identifizierung:",
          error
        );

        finish();
      }
    });
  }

  function trackSubmission(properties) {
    if (!klaviyoIsAvailable()) {
      console.warn(
        "Klaviyo ist für Formular-Tracking nicht verfügbar."
      );

      return Promise.resolve(false);
    }

    return Promise.resolve(
      window.klaviyo.track(
        "Formular abgeschickt",
        properties
      )
    )
      .then(function () {
        console.log(
          "Formular abgeschickt sent to Klaviyo:",
          properties.Formulartyp
        );

        return true;
      })
      .catch(function (error) {
        console.error(
          "Fehler beim Formular-Tracking:",
          error
        );

        return false;
      });
  }

  /*
   * Normale Shopify- und Theme-Formulare.
   */
  document.addEventListener(
    "submit",
    function (event) {
      const form = event.target;

      if (!isRelevantForm(form)) return;
      if (nativeFormsSent.has(form)) return;

      nativeFormsSent.add(form);

      const formType = getFormType(form);
      const email = getEmail(form);
      const action = String(
        form.getAttribute("action") || ""
      );

      const properties = {
        Formulartyp: formType,
        Formularname: getFormName(form, formType),
        FormularID: form.id || "",
        Quelle: "Shopify-Formular",
        HatEmailFeld: Boolean(
          form.querySelector(
            'input[type="email"], input[name="contact[email]"]'
          )
        ),
        HatNachrichtenfeld: Boolean(
          form.querySelector("textarea")
        ),
        Seite: window.location.href,
        Seitentitel: document.title
      };

      /*
       * Shopify-Kontakt- und Newsletterformulare
       * laden häufig anschließend eine neue Seite.
       * Deshalb warten wir kurz auf Klaviyo.
       */
      const shouldDelaySubmission =
        action.includes("/contact") &&
        !form.hasAttribute("data-ajax");

      if (
        !shouldDelaySubmission ||
        !klaviyoIsAvailable()
      ) {
        identifyEmail(email)
          .then(function () {
            return trackSubmission(properties);
          });

        return;
      }

      event.preventDefault();

      let formContinued = false;

      function continueFormSubmission() {
        if (formContinued) return;

        formContinued = true;

        HTMLFormElement.prototype.submit.call(form);
      }

      identifyEmail(email)
        .then(function () {
          return trackSubmission(properties);
        })
        .finally(continueFormSubmission);

      /*
       * Sicherheit: Formular wird auch bei einem
       * Klaviyo-Problem spätestens danach abgeschickt.
       */
      setTimeout(continueFormSubmission, 1500);
    },
    true
  );

  /*
   * Offizielle Klaviyo-Formularereignisse.
   */
  window.addEventListener(
    "klaviyoForms",
    function (event) {
      const detail = event.detail || {};

      if (detail.type !== "submit") return;

      const formId = String(
        detail.formId || "Unbekannt"
      );

      if (klaviyoFormsSent.has(formId)) return;

      klaviyoFormsSent.add(formId);

      trackSubmission({
        Formulartyp: "Klaviyo-Formular",
        Formularname: "Klaviyo-Formular",
        FormularID: formId,
        Quelle: "Klaviyo",
        HatEmailFeld: Boolean(
          detail.metaData &&
          detail.metaData.email
        ),
        HatNachrichtenfeld: false,
        Seite: window.location.href,
        Seitentitel: document.title
      });
    }
  );
})();